import React from 'react';
import { Typography, Box, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { HandicapIndiceData } from '../../../services/hipodromo';
import { getColors } from '../../../componetes/color_racers';

// Interfaz para las props del componente
interface HandicapIndiceProps {
    participantes: HandicapIndiceData[];
}

// --- Estilos para la información dentro de AccordionDetails (sin cambios) ---
const InfoTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    color: '#4a5568',
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
        fontSize: '0.8rem',
    },
}));

const InfoValue = styled(Typography)(({ theme }) => ({
    color: '#2d3748',
    [theme.breakpoints.down('sm')]: {
        fontSize: '0.7rem',
    },
}));

// Componente reutilizable para mostrar cada línea de información (sin cambios)
const ParticipanteInfo = ({ title, value }: { title: string; value: string | number }) => (
    <Box display="flex" flexDirection="row" alignItems="center" mb={0.5}>
        <InfoTitle variant="body2">{title}</InfoTitle>
        <InfoValue variant="body2">{value}</InfoValue>
    </Box>
);

// Componente principal adaptado para usar Accordion
const HandicapIndice: React.FC<HandicapIndiceProps> = ({ participantes }) => {
    if (!participantes || participantes.length === 0) {
        return <Typography>No hay datos de índice disponibles.</Typography>;
    }

    // === Ordenamiento añadido de nuevo ===
    // Creamos una copia y la ordenamos para no mutar la prop original
    const sortedParticipantes = [...participantes].sort((a, b) => a.inscripcion_numero - b.inscripcion_numero);
    // === Fin del ordenamiento ===


    return (
        <Box
            p={2}
            maxWidth="lg"
            width="100%"
            margin="0 auto"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >

            <Box width="100%" maxWidth="md">
                {/* === Iteramos sobre el array ordenado === */}
                {sortedParticipantes.map((participante, index) => {
                    const { color, textColor } = getColors(participante.inscripcion_numero);
                    console.log(textColor)
                    return (
                        <motion.div
                            key={participante.ejemplar_id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.01 }}
                            style={{ width: '100%' }}
                        >
                            <Accordion
                                defaultExpanded
                                sx={{
                                    mb: 1,
                                    borderLeft: `6px solid ${color || '#cccccc'}`,
                                    '&:before': { display: 'none' },
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    borderRadius: '8px',
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${participante.ejemplar_id}-content`}
                                    id={`panel${participante.ejemplar_id}-header`}
                                >
                                    <Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {participante.inscripcion_numero ?? 'N°?'}. {participante.ejemplar_name ?? 'Nombre Desconocido'}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ backgroundColor: '#fafafa' }}>
                                    {/*<ParticipanteInfo title="Jinete:" value={participante.jinete_name} />*/}
                                    {/*<ParticipanteInfo title="Preparador:" value={participante.preparador_name} />*/}
                                    {/*<ParticipanteInfo title="Peso Jinete Próx.:" value={`${participante.peso_jinete_proximo} kg`} />*/}
                                    <ParticipanteInfo title="Índice:" value={participante.indice_promedio.toFixed(2)} />
                                    <ParticipanteInfo title="Velocidad:" value={`${participante.velocidad_promedio_ms.toFixed(2)} m/s`} />
                                    <ParticipanteInfo title="Peso Total:" value={`${participante.peso_total_promedio_kg.toFixed(2)} kg`} />
                                    <ParticipanteInfo title="Resultado Pts:" value={participante.resultado_pts_promedio.toFixed(2)} />
                                    <ParticipanteInfo title="Carreras Consideradas:" value={participante.carreras_consideradas} />
                                </AccordionDetails>
                            </Accordion>
                        </motion.div>
                    );
                })}
                {/* === Fin de la iteración sobre el array ordenado === */}
            </Box>
        </Box>
    );
};

export default HandicapIndice;